import { http } from '@/lib/ats-https';

const fetchWithPolling = async (
  url,
  conditionCallback,
  toast,
  setEditorConfig,
  interval = 3000,
  maxRetries = 20
) => {
  return new Promise(async (resolve, reject) => {
    let retries = 1;
    let responseReceived = false; // Track if response is received

    const fetchData = async () => {
      try {
        const response = await http.get(url);
        responseReceived = response?.data?.generated_message?.message; // Set to true when response is received

        const shouldContinue = await conditionCallback(response);

        if (shouldContinue && retries <= maxRetries) {
          retries++;
          setTimeout(fetchData, interval);
        } else {
          // Resolve with the final result
          resolve(response);
        }
      } catch (error) {
        console.error(error);
        // Reject with the error
        reject(error);
      }
    };

    fetchData();

    // Check if response is received after all retries
    const checkResponseReceived = setInterval(() => {
      if (!responseReceived && retries > maxRetries) {
        setEditorConfig((prev) => ({
          ...prev,
          isAiLoading: false,
        }));
        toast({
          title: `Error in getting AI JD data`,
          description: '',
          status: 'error',
        });
        clearInterval(checkResponseReceived);
      }
    }, interval);
  });
};

export const generateAiContent = async (
  endPoint,
  payload,
  keyEndPoint,
  toast,
  setEditorConfig
) => {
  if (!endPoint || !keyEndPoint || Object.keys(payload).length === 0)
    return null;

  try {
    const response = await http.post(`${endPoint}`, payload);

    const conditionCallback = async (result) =>
      result?.data?.generated_message?.status === 'queued';

    const key = response?.data?.key;

    if (key) {
      // Return the final result
      return await fetchWithPolling(
        `${keyEndPoint}${key}`,
        conditionCallback,
        toast,
        setEditorConfig
      );
    }
  } catch (error) {
    console.error(error);
    throw error; // Re-throw the error to handle it in the calling code
  }
};
